import React from 'react'

const admin = () => {
  return (
    <div>admin</div>
  )
}

export default admin